import { render, staticRenderFns } from "./CampusPicker.vue?vue&type=template&id=2871fb21&"
import script from "./CampusPicker.vue?vue&type=script&lang=js&"
export * from "./CampusPicker.vue?vue&type=script&lang=js&"
import style0 from "./CampusPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports